import MyService from '../../service';

const CountryApi = {
  index: async () => {
    try {
      const { data } = await MyService.getRequestData('/countries');

      return data || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },
};

export default CountryApi;
